export const defaultApplicationList = []

export const applicationList = []

export const hotApplications = []

export const getBotHomeListFromResponse = (res) => {
  const data = res?.data ?? res
  const candidates = [
    data,
    data?.data,
    data?.params,
    data?.page,
    data?.pageResult,
    data?.result,
    data?.result?.data,
    data?.result?.page,
    data?.result?.pageResult,
  ]

  for (const candidate of candidates) {
    if (Array.isArray(candidate)) return candidate
    if (Array.isArray(candidate?.list)) return candidate.list
    if (Array.isArray(candidate?.records)) return candidate.records
    if (Array.isArray(candidate?.rows)) return candidate.rows
    if (Array.isArray(candidate?.bots)) return candidate.bots
    if (Array.isArray(candidate?.botList)) return candidate.botList
    if (Array.isArray(candidate?.hotApps)) return candidate.hotApps
    if (Array.isArray(candidate?.hotBots)) return candidate.hotBots
    if (Array.isArray(candidate?.applications)) return candidate.applications
    if (Array.isArray(candidate?.applicationList)) return candidate.applicationList
  }

  if (Array.isArray(data)) return data
  if (Array.isArray(data?.list)) return data.list
  if (Array.isArray(data?.records)) return data.records
  if (Array.isArray(data?.bots)) return data.bots
  if (Array.isArray(data?.botList)) return data.botList
  if (Array.isArray(data?.hotApps)) return data.hotApps
  if (Array.isArray(data?.hotBots)) return data.hotBots
  return []
}

export const isBotHomeSuccess = (res) => {
  return !res?.code || res.code === 'SUCCESS' || res.code === 0 || res.code === 200 || res.success === true
}

export const normalizeApplicationItem = (item, index = 0) => {
  const id = item?.id ?? item?.botId ?? item?.appId ?? item?.applicationId ?? index
  const title = item?.title ?? item?.name ?? item?.botName ?? item?.appName ?? item?.botTitle ?? item?.applicationName ?? '应用'
  const description = item?.description ?? item?.desc ?? item?.summary ?? item?.remark ?? item?.subtitle ?? item?.introduce ?? item?.intro ?? item?.content ?? ''
  const icon = item?.icon ?? item?.iconUrl ?? item?.appIcon ?? item?.botIcon ?? item?.homeIcon ?? item?.logo ?? item?.logoUrl ?? item?.cover ?? item?.coverUrl ?? item?.image ?? item?.imageUrl ?? item?.picUrl ?? ''
  const badgeSource = item?.badge ?? item?.tag ?? item?.label ?? item?.mark ?? item?.cornerMark ?? item?.badgeText
  const badge = badgeSource || (item?.hot ? 'hot' : item?.isHot ? 'hot' : item?.new ? 'new' : item?.isNew ? 'new' : item?.recommend ? 'hot' : item?.isRecommend ? 'hot' : 'none')

  return {
    ...item,
    id: String(id),
    rawId: id,
    icon,
    title,
    badge,
    description,
  }
}

export const normalizeApplicationList = (list) => {
  if (!Array.isArray(list) || !list.length) return []
  return list.map(normalizeApplicationItem)
}

export const normalizeApplicationCategories = (res) => {
  const categories = res?.data ?? res
  if (!Array.isArray(categories)) return []
  return categories.map((category) => ({
    ...category,
    categoryName: category.categoryName === '未分类' ? '常用PPT' : category.categoryName,
    apps: normalizeApplicationList(category.apps),
  }))
}

export const applicationFlowStepMap = {
  form: { key: 'basic', capability: 'form', title: '基础信息' },
  text: { key: 'text', capability: 'text', title: '文本输出', mobileTitle: '文本输出' },
  outline: { key: 'outline', capability: 'outline', title: '生成大纲' },
  ppt: { key: 'ppt', capability: 'ppt', title: '生成PPT', mobileTitle: '生成全文' },
}

export const applicationFlowSteps = Object.values(applicationFlowStepMap)

export const buildApplicationFlowSteps = (capabilities = {}) => {
  return ['form', 'text', 'outline', 'ppt']
    .filter((key) => capabilities?.[key])
    .map((key) => applicationFlowStepMap[key])
}

export const applicationWorkflowTypeByStep = {
  basic: 'FORM',
  text: 'TEXT',
  outline: 'OUTLINE',
  ppt: 'PPT',
}

const getConfigParamNames = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean)
  if (typeof value === 'string') {
    return value.split(',').map((item) => item.trim()).filter(Boolean)
  }
  if (value && typeof value === 'object') {
    return Object.values(value).filter(Boolean)
  }
  return []
}

const getConfigParamEntries = (value) => {
  if (value && !Array.isArray(value) && typeof value === 'object') {
    return Object.entries(value)
      .filter(([, fieldName]) => fieldName)
      .map(([paramName, fieldName]) => [paramName, fieldName])
  }
  return getConfigParamNames(value).map((fieldName) => [fieldName, fieldName])
}

export const normalizeWorkflowParamValue = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => normalizeWorkflowParamValue(item)).filter((item) => item !== '').join(',')
  }
  if (value && typeof value === 'object') {
    return value.url
      || value.fileUrl
      || value.response?.data?.url
      || value.response?.data?.fileUrl
      || value.response?.data
      || value.name
      || ''
  }
  return value ?? ''
}

export const buildApplicationExtParams = (formValues = {}, formParamConfigs = []) => {
  const configs = Array.isArray(formParamConfigs) ? formParamConfigs : []
  const mappedFields = new Set()

  const extParams = configs.reduce((result, config) => {
    const key = config?.key
    if (!key) return result

    const group = {}
    getConfigParamEntries(config.value).forEach(([paramName, fieldName]) => {
      mappedFields.add(fieldName)
      const fieldValue = formValues[fieldName]
      group[paramName] = normalizeWorkflowParamValue(fieldValue?.finalValue ?? fieldValue?.value ?? fieldValue)
    })

    result[key] = typeof config.fixedText === 'string' && config.fixedText
      ? flattenApplicationExtParamValues({ [key]: group }, formValues, [config])[key]
      : group
    return result
  }, {})

  // File fields may be absent from the workflow's parameter mappings.
  Object.entries(formValues).forEach(([name, field]) => {
    if (field?.formType !== 'FILE' || mappedFields.has(name)) return
    extParams[name] = {
      ...extParams[name],
      [name]: normalizeWorkflowParamValue(field.finalValue ?? field.value),
    }
  })

  const pics = Object.values(formValues)
    .filter(field => field?.formType === 'FILE')
    .flatMap(field => Array.isArray(field.pics) ? field.pics : [])
  if (pics.length) extParams.pics = pics

  return extParams
}

export const flattenApplicationExtParams = (extParams = {}) => {
  return Object.entries(extParams || {}).reduce((result, [key, value]) => {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      const entries = Object.entries(value)
      entries.forEach(([paramName, paramValue]) => {
        result[paramName] = paramValue
      })
      return result
    }
    result[key] = value
    return result
  }, {})
}

export const flattenApplicationExtParamValues = (extParams = {}, formValues = {}, formParamConfigs = []) => {
  const labels = Object.fromEntries(Object.entries(formValues).map(([name, field]) => [name, field?.label || name]))
  const configs = Array.isArray(formParamConfigs) ? formParamConfigs : []
  const fixedTexts = Object.fromEntries(configs.map(config => [config.key, typeof config.fixedText === 'string' ? config.fixedText : '']))
  const groupLabels = Object.fromEntries(configs.map((config) => [config.key,
    Object.fromEntries(getConfigParamEntries(config.value).map(([paramName, fieldName]) => [paramName, labels[fieldName] || fieldName])),
  ]))

  return Object.entries(extParams || {}).reduce((result, [key, value]) => {
    result[key] = value && typeof value === 'object' && !Array.isArray(value)
      ? (fixedTexts[key] || '') + Object.entries(value)
        .filter(([, paramValue]) => paramValue !== null && paramValue !== undefined && paramValue !== '')
        .map(([paramName, paramValue]) => `${groupLabels[key]?.[paramName] || labels[paramName] || paramName}:${paramValue}`)
        .join(';')
      : value
    return result
  }, {})
}

export const buildApplicationUserInput = (formValues = {}, fields = []) => {
  const fieldList = Array.isArray(fields) ? fields : []
  const fieldMap = fieldList.reduce((result, field) => {
    if (field?.name) result[field.name] = field
    return result
  }, {})

  return Object.entries(formValues)
    .map(([name, rawValue]) => {
      const field = fieldMap[name]
      const label = field?.label || name
      const value = normalizeWorkflowParamValue(rawValue?.finalValue ?? rawValue?.value ?? rawValue)
      if (value === '' || value == null) return ''
      return `${label}:${value}`
    })
    .filter(Boolean)
    .join(';')
}

export const getApplicationById = (id, list = []) => list.find((item) => String(item.id) === String(id)) || { id, title: '应用', badge: 'none', description: '' }
